import React from 'react';
import PropTypes from 'prop-types';
import { ItemContainer, CardTitle } from './styles';
import { Icon } from '~/shared/components';

const PrescriptionItem = ({ title, icon, ...rest }) => {
  return (
    <ItemContainer {...rest}>
      <Icon name={icon} color="gray3" />
      <CardTitle>{title}</CardTitle>
    </ItemContainer>
  );
};

PrescriptionItem.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};

PrescriptionItem.defaultProps = {
  onClick: (event) => event,
  icon: null,
  title: '',
};

export default PrescriptionItem;
